import { render, staticRenderFns } from "./TotalsBar.vue?vue&type=template&id=fb18491e"
import script from "./TotalsBar.vue?vue&type=script&lang=js"
export * from "./TotalsBar.vue?vue&type=script&lang=js"
import style0 from "./TotalsBar.vue?vue&type=style&index=0&id=fb18491e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports